// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1RfIJ","consentsList":"PatientConsents_consentsList__1OHmV","consentsListEmpty":"PatientConsents_consentsListEmpty__Yp_D-"};